import { render, staticRenderFns } from "./settings-default.vue?vue&type=template&id=125faf23&scoped=true"
import script from "./settings-default.vue?vue&type=script&lang=js"
export * from "./settings-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125faf23",
  null
  
)

export default component.exports